import React, {
    useEffect,
    useState,
} from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/en'; // 영어로 요일과 월을 표시하기 위해 영어로 설정

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import {RequestedData, userInfo} from 'state';
import styled, {keyframes} from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
    DropdownMenu,
    Overlay,
    Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CreatePopup from 'view/pages/Coaching/components/CreatePopup';
import ListItem from 'view/pages/Coaching/components/ListItem';
import RequestPopup from 'view/pages/Coaching/components/RequestPopup';
import SchListItem from "../components/SchListItem";
import SmallCalendar from "../../../components/common/SmallCalendar";
import CompletedPopup from "../components/CompletedPopup";
import {liveAPI} from "../../../../api/liveAPI";
import {SucPopup} from "../../../../styled/StyledComponent";
import SearchInputItem from "../../../components/common/SearchInputItem";

const fadeIn = keyframes`
    0% {
        opacity: 0;
        transform: translateY(-10px) scale(0.8);
    }
    50% {
        opacity: 0; /* 중간 상태에서 조금 투명하게 */
    }
    60% {
        opacity: 0; /* 중간 상태에서 조금 투명하게 */
    }
    100% {
        transform: scale(0.8);
        opacity: 1;
    }
`;

const rangeArr = ["Today","This week","This month","All time"];
const tabList = ["Upcomming", "In Progress"]
const Scheduled = (props) => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const reqData = useRecoilValue(RequestedData)
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [coachingTitle, setCoachingTitle] = useState("")
    const [selectClass, setSelectClass] = useState(null);
    const [completed, setCompleted] = useState(true);
    const [comPopup, setComPopup] = useState(false);
    const [sucAlert, setSucAlert] = useState(false);
    const [received, setRceived] = useState(true);
    const [indexValue, setIndexValue] = useState({
        i: 0,
        v: 5,
    });
    const [range, setRange] = useState("All time")
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const [popupDate, setPopupDate] = useState(new Date());
    const [endPopupDate ,setEndPopupDate] = useState(new Date());
    const [datePopup, setDatePopup] = useState(false);
    const [tab, setTab] = useState("Upcomming")
    const onClickPopupDate = (date) => {
        setPopupDate(date)
    };
    const onClickEndPopupDate = (date) => {
        setEndPopupDate(date)
    }
    console.log("@popupDate",popupDate, dayjs(popupDate).format("YYYY-MM-DD"));

    const handleDateRangeButtonClick = (range) => {
        switch(range) {
            case 'This week':
                const thisWeekStart = dayjs().startOf('week').toDate();
                const thisWeekEnd = dayjs().endOf('week').toDate();
                setPopupDate(dayjs().startOf('day').toDate());
                setEndPopupDate(thisWeekEnd);
                break;
            case 'This month':
                const thisMonthStart = dayjs().startOf('month').toDate();
                const thisMonthEnd = dayjs().endOf('month').toDate();
                setPopupDate(dayjs().startOf('day').toDate()); // 현재 날짜의 시작 부분
                setEndPopupDate(thisMonthEnd);
                break;
            case 'Today':
                const today = new Date();
                setPopupDate(today);
                setEndPopupDate(today);
                break;
            case 'All time':{

                getCoachingList(true)
            }
                // All time에 해당하는 범위를 설정하십시오.
                break;
            default:
                break;
        }
    };

    const getClassItem = async () => {
        const result = await classesAPI
            .getClassList({
                //     unpaged:true,
                //    sort:{
                //     sorted:false
                //    },
            })
            .then((res) => {
                setClassList(cloneDeep(res?.content));
                return res?.content;
            });
        return result;
    };
    const getCoachingList = async (allTime = false) => {
        liveAPI.getRequestData({
            params:{
                coachingStatus:"SCHEDULED"
            }
        })
            .then(res => {
                const c = cloneDeep(res?.data?.content)
                console.log("@res",res);
                const sortData = c?.sort((a, b) => {
                    const dateComparison = a.coachingApplication.liveCoaching.liveCoachingSlot.localDate.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.localDate);
                    if (dateComparison !== 0) {
                        return dateComparison;
                    }
                    return a.coachingApplication.liveCoaching.liveCoachingSlot.startTime.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.startTime);
                });

                const s = new Date(dayjs(new Date).format("YYYY-MM-DD 00:00:00")).getTime()
                const filteredData = sortData?.filter(item => {
                    const currentDate = new Date(item.coachingApplication.liveCoaching.liveCoachingSlot.localDate).getTime();
                    console.log("@currentDate",currentDate);
                    return tab == "Upcomming" ? s <= currentDate : s >= currentDate;
                });
                if(allTime){
                    setList(cloneDeep(filteredData))
                }else{
                    getRange(cloneDeep(filteredData));
                }
            })
    };

    console.log("@tab",tab);
    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            ?.filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const createCoaching = async () => {
        coachingAPI.createCoaching({
            params:{
                classesId:selectClass?.id,
                title:coachingTitle
            }
        })
            .then(res => {
                if(res?.success === true && !isEmpty(res?.data?.id)){
                    navigate("/create_coaching/details",{
                        state:{
                            createId:res?.data?.id
                        }
                    })
                }
            })
    };

    console.log('selectClass', selectClass)

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));

        setComPopup(true)
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    useEffect(() => {
        if(range !== "All time"){
            getCoachingList(false);
        }

    },[popupDate,endPopupDate, range, tab]);

    useEffect(() => {
        getCoachingList(true);
    },[tab]);


    // useEffect(() => {
    //     getCoachingList(pageInfo?.number);
    // }, [pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [indexValue?.v]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [selectClass?.id]);

    // useEffect(() => {
    //     getClassItem();
    // }, []);

    const getDateTag = (date, id:any) => {
        const c = cloneDeep(list);
        const findList = c?.filter(item => {
            return date == item?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate;
        });
        const sortData = findList?.sort((a, b) => {
            const dateComparison = a.coachingApplication.liveCoaching.liveCoachingSlot.localDate.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.localDate);
            if (dateComparison !== 0) {
                return dateComparison;
            }
            return a.coachingApplication.liveCoaching.liveCoachingSlot.startTime.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.startTime);
        });
        return sortData[0]?.coachingApplication?.id == id
    };

    const getRange = (list) => {
        const c = cloneDeep(list)
        const startDate = dayjs(popupDate).format("YYYY-MM-DD 00:00:00");
        const endDate = dayjs(endPopupDate).format("YYYY-MM-DD 11:59:59");
        const s = new Date(startDate).getTime();
        const e = new Date(endDate).getTime();
        // 날짜 범위에 해당하는 데이터 필터링
        const filteredData = c?.filter(item => {
            const currentDate = new Date(item.coachingApplication.liveCoaching.liveCoachingSlot.localDate).getTime();
            console.log("@currentDate",currentDate);
            // @ts-ignore
            return s <= currentDate && e >= currentDate
        });
        setList(cloneDeep(filteredData))
        console.log("@filteredData",filteredData, s, e);
    };


    console.log("list",list);
    console.log("@popupDate",popupDate, endPopupDate);

    return (
        <Container>
            {
                sucAlert &&
                <SucPopup style={{top: "8%", position: "fixed"}}>
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M16.9684 5.03712C15.0479 4.18139 12.9023 3.9694 10.8514 4.43276C8.80063 4.89611 6.95453 6.00999 5.58849 7.60826C4.22244 9.20653 3.40964 11.2036 3.2713 13.3015C3.13296 15.3995 3.6765 17.486 4.82085 19.2498C5.9652 21.0136 7.64905 22.3602 9.62127 23.0888C11.5935 23.8175 13.7484 23.8891 15.7646 23.2929C17.7809 22.6968 19.5504 21.4649 20.8093 19.7809C22.0682 18.0969 22.749 16.0511 22.7502 13.9486V12.9526C22.7502 12.3543 23.2352 11.8692 23.8335 11.8692C24.4318 11.8692 24.9168 12.3543 24.9168 12.9526V13.9492C24.9154 16.519 24.0833 19.02 22.5446 21.0782C21.006 23.1364 18.8432 24.6421 16.379 25.3707C13.9147 26.0993 11.2809 26.0118 8.87041 25.1212C6.45992 24.2307 4.40188 22.5848 3.00322 20.429C1.60457 18.2733 0.940247 15.7231 1.10933 13.159C1.27841 10.5948 2.27183 8.15398 3.94145 6.20053C5.61106 4.24709 7.8674 2.88569 10.374 2.31936C12.8805 1.75304 15.503 2.01214 17.8503 3.05802C18.3968 3.30153 18.6424 3.94197 18.3989 4.48849C18.1554 5.035 17.5149 5.28063 16.9684 5.03712Z"
                              fill="#333333"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M24.5988 4.51614C25.0221 4.93899 25.0224 5.62492 24.5996 6.0482L13.7663 16.8924C13.5631 17.0957 13.2875 17.21 13.0001 17.2101C12.7127 17.2101 12.437 17.096 12.2338 16.8928L8.9838 13.6428C8.56074 13.2197 8.56074 12.5338 8.9838 12.1107C9.40687 11.6876 10.0928 11.6876 10.5159 12.1107L12.9995 14.5943L23.0668 4.5169C23.4896 4.09362 24.1755 4.09328 24.5988 4.51614Z"
                              fill="#333333"/>
                    </svg>
                </SucPopup>
            }
            {popup && (
                <Overlay filter={true}>
                    <RequestPopup data={selectedData} onClickPopup={()=>{
                        getCoachingList();
                        setPopup(v => !v);
                    }} />
                </Overlay>
            )}
            {
                comPopup &&
                <Overlay filter={true}>
                    <CompletedPopup
                        scheduled={true}
                        data={selectedData}
                        onClickGetList={()=>{
                            setSucAlert(true)
                            setTimeout(()=>{
                                setSucAlert(false)
                            },1500)
                            getCoachingList(true)
                        }}
                        onClickPopup={()=>{
                        setComPopup(false)
                    }}/>
                </Overlay>
            }
            <ContentsInner>
                <div className="title">
                    <h1>Scheduled events</h1>
                    <div className="statusList">
                        <div>
                            <div className="circle" style={{
                                background:"rgba(255, 179, 186, 1)"
                            }}>

                            </div>
                            <span>Pending</span>
                        </div>
                        <div>
                            <div className="circle" style={{
                                background: "rgba(186, 225, 255, 1)"
                            }}>
                            </div>

                            <span>Scheduled</span>
                        </div>
                        <div>
                            <div className="circle" style={{
                                background: "rgba(186, 255, 201, 1)"
                            }}>
                            </div>
                            <span>Join a video call</span>
                        </div>
                    </div>
                </div>

                <h4>Date range</h4>
                <SearchArea style={{marginBottom: 15}}>
                    <DropDownArea style={{width: 260}}
                                  onClick={()=>{setDatePopup(v => !v)}}
                                  className={`${datePopup ? "on" : ""}`}
                    >
                        <input type="text" readOnly={true}
                          value={`${dayjs(popupDate).format('DD MMM YYYY')} - ${dayjs(endPopupDate).format('DD MMM YYYY')}`}
                        />
                        <svg className={"arrow"} width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.67969L5.5 6.17969L10 1.67969" stroke="#333333" strokeWidth={"2"}
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {
                            datePopup &&
                            <PopupArea
                                onClick={(e)=>{
                                    e.stopPropagation();
                                }}
                            >
                                <PopupHeader>
                                    {
                                        rangeArr.map((item) => {
                                            return(
                                                <span
                                                    onClick={()=>{
                                                        setRange(item);
                                                        handleDateRangeButtonClick(item);
                                                    }}
                                                    className={`${range === item ? "on" : ""} `}
                                                >{item}</span>
                                            )
                                        })
                                    }

                                </PopupHeader>
                                <CalArea>
                                    <SmallCalendar popupDate={popupDate} onClickPopupDate={(date)=>{
                                        setRange("Custom")
                                        onClickPopupDate(date)
                                    }}>
                                    </SmallCalendar>
                                    <SmallCalendar popupDate={endPopupDate}
                                                   minDate={popupDate}
                                                   onClickPopupDate={(date)=>{
                                        setRange("Custom")
                                        onClickEndPopupDate(date)
                                    }}>
                                    </SmallCalendar>
                                </CalArea>
                                <CalBtn>
                                    <span
                                        onClick={()=>{setDatePopup(false)}}
                                    >Cancel</span>
                                    <span
                                        onClick={()=>{setDatePopup(false)}}
                                    >Apply</span>
                                </CalBtn>
                            </PopupArea>
                        }
                    </DropDownArea>
                    <SearchInputItem/>
                </SearchArea>
                <Wrap>
                    <ListTopContents>
                        {tabList.map((item) => {
                            return (
                                <span
                                    className={tab == item ? "on" : ""}
                                    onClick={()=>{
                                        setTab(item)
                                    }}
                                >{item}</span>
                            )
                        })}

                    </ListTopContents>

                    <List
                        onClick={(e)=>{
                            e.stopPropagation();
                        }}
                    >
                        {
                           list?.map(item => {
                                return(
                                    <React.Fragment>
                                        {
                                            getDateTag(item?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate, item?.coachingApplication?.id)
                                            &&
                                            <DateItem
                                                // onClick={()=>{
                                                //     getDateTag(item?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate)
                                                // }}
                                            >
                                            <span>
                                            {dayjs(item?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate).format('dddd')},
                                            </span>
                                                &nbsp;
                                                <p>
                                                    {dayjs(item?.coachingApplication?.liveCoaching?.liveCoachingSlot?.localDate).format('DD MMM YYYY')}
                                                </p>
                                            </DateItem>
                                        }
                                        <SchListItem
                                            onClickPopup={()=>{
                                                onClickGetData(item)
                                            }}
                                            data={item}/>
                                    </React.Fragment>

                                )
                            })
                        }
                        {
                            isEmpty(list) &&
                            <div className="img">
                                <img src="/images/nothingSchdule.png" alt=""/>
                                <p>
                                    No {tab} events
                                </p>
                            </div>
                        }
                    </List>
                    <SaveBtn>
                        <span>Save</span>
                    </SaveBtn>
                </Wrap>

            </ContentsInner>
            {/*<Pagenation*/}
            {/*    totalPage={pageInfo?.totalPages}*/}
            {/*    onClickMove={(isNext) => {*/}
            {/*        onClickMovePage(isNext);*/}
            {/*    }}*/}
            {/*    size={pageInfo?.size}*/}
            {/*    pageNumber={pageInfo?.number}*/}
            {/*/>*/}

        </Container>
    );
};
export default Scheduled;

const Container = styled.div`
    height: calc(100vh - 80px);
    position: relative;
`;
const PopupArea = styled.div`
    animation: ${fadeIn} 0.3s ease-in-out; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    position: absolute;
    z-index: 99999;
    height: 530px;
    max-height: 530px;
   
    transform-origin: left top;
    left: 0;
    top: calc(100% + 15px);
    padding: 20px 10px;
    border-radius: 12px;
    transition: all 0.2s;
    cursor: pointer;
    h1{
        display: none;
    }
    background: #fff;
    border: 1px solid rgba(51, 51, 51, 1);
    .calendarWrapper{
        margin:0 10px;
        box-shadow: none;
        border: 0.4px solid rgba(51, 51, 51, 0.2);
        border-radius: 6px;
    }
`
const PopupHeader = styled.div`
    padding: 0 10px;
    margin-bottom: 20px;
    span {
        transition: color, border-bottom-color 0.2s;
        
        border-bottom: rgba(51, 51, 51, 0) solid 2px;
        cursor: pointer;
        margin-right: 20px;
        padding-bottom: 5px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 0.4);

        &.on {
            border-bottom: rgba(51, 51, 51, 1) solid 2px;
            font-family: Europa-Bold;
            font-size: 18px;
            font-weight: 700;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            color: rgba(51, 51, 51, 1);
        }
    }
`
const CalArea = styled.div`
   display: flex;
`
const CalBtn = styled.div`
    position: absolute;
    left: 0;
    bottom: 15px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    span{
        margin: 0 10px;
        padding: 10px 0;
        justify-content: center;
        border-radius: 4px;
        display: flex;
        cursor: pointer;
        width: calc((50% - 20px) / 2);
        border: solid 1px #333;
        &:last-child{
            background: #333;
            color: #fff;
        }
    }
`
const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    height: calc(100vh);
    .title{
        cursor: default;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .statusList{
        display: flex;
        & > div{
            margin-left: 30px;
            display: flex;
            align-items: center;
            span{
                margin-left: 15px;
                font-family: Europa-Bold;
                font-size: 16px;
                font-weight: 700;
                line-height: 16px;
                letter-spacing: 0px;
                text-align: left;
                color: rgba(51, 51, 51, 1);
            }
        }
        .circle{
            width: 26px;
            height: 26px;
            min-width: 26px;
            max-width: 26px;
            border-radius: 50%;
            background: #ddd;
        }
    }
    h4{
        font-family: Europa-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
    
    }
    h1{
        font-family: Europa-Bold;
        font-size: 26px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 20px;
    }
`;
const SaveBtn = styled.div`
   display: flex;
    justify-content: flex-end;
    padding: 20px;
    span{
        cursor: pointer;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #333;
        width: 160px;
        height: 40px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
    }
`
const List = styled.div`
    height:calc(100vh - 395px);
    overflow-y: auto;
    flex-grow: 1;
    .img{
        border-top: 1px solid rgba(51, 51, 51, 0.2);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        img{
            display: flex;
            flex-direction: column;
            height: 60%;
            margin-bottom: 15px;
            object-fit: contain;
       
        }
        p{
            font-family: Europa-Bold;
            font-size: 16px;
            font-weight: 700;
            line-height: 16px;
            letter-spacing: 0em;
            text-align: left;
            color: rgba(51, 51, 51, 1);
        }
    }
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
    scroll-behavior: smooth;
`
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    box-shadow: 0px 0px 10px 0px rgba(221, 193, 96, 0.5);
    border-radius: 15px;
    background: #fff;
`;
const DateItem = styled.div`
    display: flex;
    align-items: center;
    padding: 20px;
    background: rgba(245, 245, 245, 1);
    border-top: 1px rgba(51, 51, 51, 0.2) solid;
    border-bottom: 1px rgba(51, 51, 51, 0.2) solid;
    span{
    

       font-family: Europa-Bold;
       font-size: 18px;
       font-weight: 700;
       line-height: 18px;
       letter-spacing: 0em;
       text-align: left;

   }
    p{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }
`
const ListTopContents = styled.div`
    padding: 20px;
    display: flex;
    transition: all 0.2s;
    span {
        padding-bottom: 5px;
        cursor: pointer;
        margin-right: 20px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 700;

        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 0.4);
        border-bottom: solid 2px rgba(51, 51, 51, 0);

        &.on {
            font-family: Europa-Bold;
            font-size: 18px;
            font-weight: 700;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            color: rgba(51, 51, 51, 1);
            border-bottom: solid 2px rgba(51, 51, 51, 1);
        }
    }
`
const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
        margin-right: 15px;
        font-weight: 700;
        color: "#333";
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    .yellow{
        min-width: 300px;
        &.addHeight{
            height: 44px;
        }
        & > div{
            background: rgba(252, 201, 34, 1)
        }
        input{
            border: 1px solid rgba(252, 201, 34, 1);
        }
    }
`;
const DropDownArea = styled.div`
    display: flex;
    width: 30%;
    cursor: pointer;
    position: relative;
    .arrow{
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
    &.on{
        .arrow{
        }
    }
height: 44px;
border-radius: 8px;
border: 1px;
    input{
        cursor: pointer;
        width: 100%;
        display: flex;
        border: 1px solid rgba(51, 51, 51, 0.3);
        border-radius: 8px;
        outline: none;
        padding: 12px 16px;

        font-family: Europa-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;

    }

`;
const InputArea = styled.div`
    display: flex;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    align-items: center;
    flex-direction: row;
    width: 300px;
    div {
        height: 100%;
        box-sizing: border-box;
        padding: 0 8px;
        background: rgba(252, 201, 34, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            padding-bottom: 3px;
        }
        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 8px;
        }
    }
    input {
        padding-left: 15px;
        outline: none;
        display: flex;
        height: 100%;
        width: 100%;
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: 1px solid rgba(252, 201, 34, 1);
        border-right: none;
        &::placeholder {
            opacity: 0.5;
        }
    }
`;
const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
    background: #fff;
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    h5 {
        font-weight: 700;
        font-size: 18px;
        transform: translate(-20px, -7px);
    }
`;
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span {
        text-align: center;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: center;
    }
`;
const SliderWrap = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;

    .horizontal-slider {
        display: flex;
        align-items: center;

        .active {
            width: 16px;
            height: 16px;
            border: solid 1px red;
            background: red;
        }
        span {
            &:nth-child(1) {
                background: #fff;
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;

            .indexItem {
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .thumb {
            border-radius: 50%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;

const ListContainer = styled.div`
   
`